import axios from "axios";
import { CONVERSATIONS_ITEM_REJECT } from "./type";
import { CHAT_CONVERSATION } from "endpointsConst";

export function rejectConversationItem(conversationId, item, lang) {
    const { type, id, conversation_entity_id } = item;

    return async (dispatch) => {
        try {
            await axios
                .delete(
                    `${CHAT_CONVERSATION}/${conversationId}/${conversation_entity_id}/reject/${id}`,
                    {
                        params: { type, lang },
                    },
                )
                .then(() => {
                    dispatch({
                      type: CONVERSATIONS_ITEM_REJECT,
                      payload: {
                        conversation_id: conversationId,
                        type,
                        type_id: id,
                        isMyChanges: true,
                      },
                    });
                });
        } catch (error) {
            // TODO handle error
        }
    };
}
